<template>
  <div>
    <Topnav title="Courses"></Topnav>
    <Sidebar></Sidebar>
    <div class="content-wrapper" style="background: white">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="dots"
        :is-full-page="fullPage"
        :height="height"
        :width="width"
        background-color="#6b6969"
      ></loading>
      <div class="content-header">
        <div class="custom-container-fluid">
          <div class="row">
            <h6 class="col-12 mb-5" style="font-size: 14px;">
              {{ module.title }} > LESSONS >
              <span class="badge badge-green pt-2 pb-2">{{
                (selected_topic || {}).title
              }}</span>
            </h6>
            <div class="col-md-9">
              <div class="timeline cursor-pointer">
                <!-- timeline item -->
                <div
                  v-for="(c, i) in (selected_topic || {})
                    .CoachSchoolModuleVideos"
                  :key="i"
                >
                  <i class="fa bg-green"></i>
                  <div class="timeline-item" @click="playVideo(c)">
                    <div class="timeline-body">
                      <div class="row">
                        <div class="col-md-1">
                          <i class="fa fa-play-circle player_icon" />
                          <img
                            src="@/assets/course_img.png"
                            style="width: 50px; height: 40px"
                            alt=""
                          />
                        </div>

                        <div class="col-md-9 mt-1">
                          <h4 class="mt-0 text-dark text-center">
                            {{ c.title }}
                          </h4>
                        </div>
                        <div class="col-md-2 mt-1 text-right text-green">
                          14 mins
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    selected + 1 ===
                      ((module || {})['CoachSchoolModuleTopics'] || []).length
                  "
                >
                  <i class="fas bg-green"></i>
                  <div class="timeline-item">
                    <div
                      class="timeline-body bg-orange"
                      @click="
                        $router.push('/dashboard/quiz/' + $route.params.id)
                      "
                    >
                      <div class="row text-light">
                        <div class="col-md-6">Take Quiz</div>
                        <div class="col-md-6 text-right">60 mins</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    selected + 1 <
                      ((module || {})['CoachSchoolModuleTopics'] || []).length
                  "
                >
                  <i class="fas bg-green"></i>
                  <div class="timeline-item">
                    <div class="timeline-body bg-green" @click="nextTopic">
                      <div class="row text-light">
                        <div class="col-md-6 text-capitalize">
                          Next:
                          {{
                            module.CoachSchoolModuleTopics[selected + 1][
                              "title"
                            ]
                          }}
                        </div>
                        <div class="col-md-6 text-right">60 mins</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div
                class="card mt-0 mb-1 cursor-pointer"
                :class="[selected === i ? 'bg-green text-light' : '']"
                style="border-radius: 5px"
                v-for="(c, i) in module.CoachSchoolModuleTopics"
                :key="i"
                @click="selectTopic(i)"
              >
                <div class="card-body">
                  <div class="row">
                    <div class="col-12">
                      <div class="">
                        {{ c.title }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card" style="border-radius: 12px; margin-top: 7rem">
                <div class="card-body">
                  <div class="row">
                    <div class="col-3">
                      <img
                        class="img-fluid mt-1"
                        :src="
                          (module || {}).course_instructor_img
                            ? (module || {}).course_instructor_img
                            : '@/assets/course_img.png'
                        "
                        style="width: 50px; height: 50px; border-radius: 50%"
                        alt=""
                      />
                    </div>
                    <div class="col-9">
                      <div class="mb-2 mt-2" style="color: #727272">
                        Course Instructor
                      </div>
                      <div class="">
                        {{ (module || {}).course_instructor_name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mt-0" style="border-radius: 12px">
                <div class="card-body">
                  <img
                    class="img-fluid mt-1 mb-2"
                    src="@/assets/cert.png"
                    alt=""
                  />
                  <h4>Certificate of completion</h4>
                  <p>
                    Every course comes with a shareable certificate that you can
                    add to your LinkedIn or CV to verify your newly acquired
                    skills. You can share your certificate on your LinkedIn
                    profile, on printed resumes, CV’s or hang it on your wall.
                  </p>
                </div>
              </div>
              <div class="text-green mt-4 ">Download certificate</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    video modal here-->
    <div
      class="modal fade"
      id="videoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="videoModalLable"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <VideoComponent
          :src="video_src"
          :next_course="
            selected + 1 <
              ((module || {})['CoachSchoolModuleTopics'] || []).length
          "
          @clicked="onClickChild"
          :key="comics_reload"
        ></VideoComponent>
      </div>
    </div>

    <!--    end of video modal-->
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import "vue-loading-overlay/dist/vue-loading.css";
// import '../../../public/plugins/datatables/jquery.dataTables.min.js';
// import 'datatables.net-select';
import Swal from "sweetalert2";

export default {
  name: "Module-Details",
  data() {
    return {
      module: {},
      selected: 0,
      isLoading: false,
      fullPage: true,
      height: 128,
      width: 128,
      selected_topic: [],
      selected_video: {},
      next_course: false,
      video_src: "",
      comics_reload: 0,
      reach_id: {
        topic_id: 2,
        video_id: 2
      }
    };
  },
  components: {
    Loading: () => import("vue-loading-overlay"),
    Sidebar: () => import("@/components/Dashboard-sidebar"),
    // foot: () => import('@/components/footer_component'),
    Topnav: () => import("@/components/Dashboard-topnav"),
    VideoComponent: () => import("@/components/VideoComponent")
  },
  methods: {
    onClickChild() {
      this.nextTopic();
    },
    playVideo(course) {
      console.log(course);
      this.video_src =
        "https://marketplace.canva.com/EAE53nUzEX4/1/0/800w/canva-brown-%26-yellow-jewelry-shop-golden-modern-intro-video--KeWYzKIoX0.mp4";
      if (course.title === "Video of module 1") {
        this.video_src = "mountain";
      }
      this.comics_reload++;

      window.$("#videoModal").modal("show");
    },
    getModules() {
      this.isLoading = true;
      axios
        .get(
          `${process.env.VUE_APP_COMPANY_URL}/modules/${this.$route.params.id}`,
          this.data
        )
        .then(res => {
          this.module = res.data.data;
          let current_module = (this.module || {}).CoachSchoolModuleTopics.find(
            e => {
              if (e.id == this.reach_id.topic_id) {
                return e;
              }
            }
          );

          if (((this.module || {}).CoachSchoolModuleTopics || []).length > 0) {
            this.selectTopic(0);
          }
        })
        .catch(err => {
          Swal.fire({
            title: "Error!",
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "ok"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    nextTopic() {
      this.selected++;
      this.selected_topic = ((this.module || {}).CoachSchoolModuleTopics || {})[
        this.selected
      ];
    },

    selectTopic(i) {
      this.selected = i;
      console.log(this.selected, "selected");
      this.selected_topic = ((this.module || {}).CoachSchoolModuleTopics || {})[
        i
      ];
    }
  },
  async created() {
    this.getModules();

    document.title = "Transcript || GTL Coach School";
    window.$(".index-page").removeClass("sidebar-open");
    setTimeout(() => {
      window.$(".nav-link").removeClass("active");
      window.$("#transcript").addClass("active");
    }, 100);

    // this.getCompanyJobs();
  }
};
</script>

<style scoped>
.timeline-item {
  box-shadow: none !important;
  border: 1px solid #dee2e6 !important;
}
.timeline > div > .timeline-item > .timeline-body,
.timeline > div > .timeline-item > .timeline-footer {
  padding: 32px 16px;
  border-radius: 10px;
}
.timeline > div > .timeline-item {
  border-radius: 10px !important;
}
.player_icon {
  position: absolute;
  margin-right: 10px;
  left: 0;
  right: 0;
  top: 10px;
  text-align: center;
  color: white;
}
.timeline::before {
  margin: 40px 0 !important;
}
.timeline > div > .fa,
.timeline > div > .fas,
.timeline > div > .far,
.timeline > div > .fab,
.timeline > div > .glyphicon,
.timeline > div > .ion {
  top: 20px !important;
}
</style>
